// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"f8297347","170":"7359f14a","281":"486712f4","294":"7d494df4","552":"854c3839","618":"3e612692"}[chunkId] + ".chunk.js";
};